import {ENC} from './decrypt_pwd'

export const redmine = {
  domain: 'https://smeestage.gapinc.com/',
  adminApiKey: ENC('U2FsdGVkX1+HEyD02h8pcKqBHm92dZW/Yd+KfZdBqI+9JmDJEIEPVuaSSpdRpM8LUpOnG76d/FIJkDMyqf1bvg==')
}
export const microservice = {
  domain: '/smee'
}
export const smee = {
  complexServiceUrl: 'https://rpt-search-service-production.apps.cfprod.phx.gaptech.com/rpt-search-service/sourcing/responsive-product-groups/search',
  userName: 'rpt_client',
  passWord: ENC('U2FsdGVkX1+SD0RwpGKaxzVhilHGLgeIiVbDpSHQRPoipNw2QFjYoqePUcI1izQE'),
  sharepoint: {
    vpseFolderId: 'SMEEstage/vpse',
    trmFolderId: 'SMEEstage/trm',
    qasFolderId: 'SMEEstage/qas',
    pclFolderId: 'SMEEstage/pcl',
    wipFolderId: 'SMEEstage/wip',
    mstVendorConnectFolderId: 'SMEEstage/mst',
    commitmentFolderId: 'SMEEstage/commitment'
  }
}

export const redbannerScheduler = {
  redbannerStartTime: '22:00:00',
  redbannerEndTime: '23:59:00'
}

// Below property is added to make no. of universal CC# per page configurable on "Initiate Ad Sample Requests" screen as part of Card No. SMEE-1794
export const rowsPerPageOptions = [20, 50, 100]

// Redirect URL to the new booking application
export const newBookingApplicationUrl = 'https://gisbookingstage.gapinc.com/'



// WEBPACK FOOTER //
// ./src/app-config.js